// src/app/features/dashboard/admin/stats/PieChartStats.tsx
import { ReactNode } from 'react';
import CustomPieChart from '../../shared/CustomPieChart';

interface IUserStat {
  name: string;
  value: number;
  label?: ReactNode;
}

interface IUserStats {
  data: IUserStat[];
  total: number;
  colors: string[];
  /** new: whether to render the “xx%” column in the legend */
  showPercentage?: boolean;
}

const PieChartStats = ({
  data,
  total,
  colors,
  showPercentage = true,
}: IUserStats) => {
  // choose grid‐layout based on whether we show % or not
  const gridCols = showPercentage
    ? 'grid-cols-[1rem_2.5rem_2.5rem_auto]'
    : 'grid-cols-[1rem_2.5rem_auto]';

  const chartData = data.map(({ name, value }) => ({ name, value }));

  return (
    <div className="flex flex-col md:flex-row items-start gap-6 p-4 border border-gray-300 rounded shadow w-full">
      {/* Chart */}
      <div className="w-full max-w-xs h-64 mx-auto md:mx-0">
        <CustomPieChart data={chartData} colors={colors} />
      </div>

      {/* Legend */}
      <div className="flex flex-col gap-2 w-full md:w-auto text-sm">
        {data.map(({ name, value, label }, i) => {
          const color = colors[i % colors.length];
          const percentage =
            total > 0 ? ((value / total) * 100).toFixed(0) : '0';

          return (
            <div key={i} className={`grid ${gridCols} items-center gap-x-1`}>
              <div
                className="w-3 h-3 rounded-full"
                style={{ backgroundColor: color }}
              />
              <span className="font-semibold">{label ?? value}</span>
              {showPercentage && total !== 0 && (
                <span className="font-bold">{percentage}%</span>
              )}
              {/* <span className="capitalize">{name}</span> */}
              <span className={`capitalize ${!showPercentage ? 'ml-2' : ''}`}>
                {name}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PieChartStats;
